import { useCurrentPlan } from "./useCurrentPlan"
import { useFlipperFlag } from "./useFlipperFlag"

export const useTrialStatus = () => {
  const { data: currentPlan, isLoading } = useCurrentPlan()
  const isNewRegistration = useFlipperFlag('new_registration')
  const trialDaysLeft = currentPlan?.trial_days_left ?? -1
  const isInTrial = isNewRegistration && trialDaysLeft > 0

  return {
    trialDaysLeft,
    isInTrial,
    isLoading,
  }
}
